import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0c7035d8")

_pushScopeId("data-v-0c7035d8")
const _hoisted_1 = { class: "p-field p-m-4" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "contentName",
  class: "kn-material-input-label"
}
const _hoisted_4 = {
  key: 0,
  class: "p-error p-grid p-mt-2"
}
const _hoisted_5 = { class: "p-field p-m-4" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "contentCode",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-m-4" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "contentDescription",
  class: "kn-material-input-label"
}
const _hoisted_11 = { id: "description-help" }
const _hoisted_12 = { id: "description-help" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    breakpoints: _ctx.glossaryDefinitionDialogDescriptor.dialog.breakpoints,
    style: _ctx.glossaryDefinitionDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    header: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.content.CONTENT_ID ? _ctx.$t('managers.glossary.glossaryDefinition.editNode') : _ctx.$t('managers.glossary.glossaryDefinition.newNode')), 1)
    ]),
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        label: _ctx.$t('common.save'),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('save', _ctx.content))),
        class: "kn-button kn-button--primary",
        disabled: _ctx.buttonDisabled
      }, null, 8, ["label", "disabled"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_InputText, {
            id: "contentName",
            class: ["kn-material-input", {
                        'p-invalid': _ctx.content.CONTENT_NM?.length === 0 && _ctx.contentNameDirty
                    }],
            modelValue: _ctx.content.CONTENT_NM,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.content.CONTENT_NM = $event)),
            modelModifiers: { trim: true },
            max: "100",
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.contentNameDirty = true))
          }, null, 8, ["modelValue", "class"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.name')) + " *", 1)
        ]),
        (_ctx.content.CONTENT_NM.length === 0 && _ctx.contentNameDirty)
          ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.name') })), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_InputText, {
            id: "contentCode",
            class: "kn-material-input",
            modelValue: _ctx.content.CONTENT_CD,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.content.CONTENT_CD = $event)),
            modelModifiers: { trim: true },
            max: "30"
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.glossary.common.code')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("span", _hoisted_9, [
          _createVNode(_component_Textarea, {
            id: "contentDescription",
            class: "kn-material-input",
            modelValue: _ctx.content.CONTENT_DS,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.content.CONTENT_DS = $event)),
            modelModifiers: { trim: true },
            autoResize: true,
            maxLength: "500",
            rows: "1"
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.description')), 1)
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("small", _hoisted_12, _toDisplayString(_ctx.descriptionHelp), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["breakpoints", "style", "visible"]))
})